import {Role} from "../../api/Model";
import {useAuthStore} from "../../app-layout/authStore";
import {rolesOf} from "./Access";

export function roleAsString(roles: readonly Role[]): string {
    return roles
        .map(role => {
            switch (role.type) {
                case "guest":
                    return "guest";
                case "vault-manager":
                    return `vault-manager(office=${role.officeId}, vault=${role.vaultId})`;
                case "office-admin":
                    return `office-admin(office=${role.officeId})`;
                case "system-admin":
                    return "system-admin";
            }
            return '';
        })
        .sort()
        .join(', ');
}

export function onRoleChange(listener: (roles: readonly Role[], prevRoles: readonly Role[]) => void) {
    useAuthStore.subscribe((state, prevState) => {
        const roles = rolesOf(state.user);
        const prevRoles = rolesOf(prevState.user);

        if (roleAsString(roles) !== roleAsString(prevRoles)) {
            listener(roles, prevRoles);
        }
    });
}